import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/ui/library/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import styled from 'src/ui/library/styled';
//import withMobileDialog from '@material-ui/core/withMobileDialog';
import CloseIcon from '@material-ui/icons/Close';

const styles = (theme, props) => ({
  root: {},
  rootPaper: {
    padding: '32px',
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  title: {
    padding: '0px',
    margin: '0px',
    fontSize: '24px',
    color: theme.colors.eyConfidentGrey,
    flexGrow: 1,
  },
  closeIcon: {
    cursor: 'pointer',
  },
  divider: {
    marginTop: '40px',
    height: '1px',
    width: '100%',
    border: '0.5px solid #CCC',
    opacity: '0.7',
  },
  contentRoot: {
    padding: '32px 0px 0px 0px',
  },
  contentText: {
    color: theme.colors.eyConfidentGrey,
    fontSize: '14px',
  },
  actionsRoot: {
    flexDirection: props.dialogClassName==="priceLockInfoDialog"?'row-reverse':'row',
    margin: '24px 0px 0px 0px',
    justifyContent: 'flex-start',
    width: '100%',
    maxWidth: '450px',
  },
  buttonAction: {
    margin: '0px 16px 0px 0px',
  },
});

class ConfirmDialog extends React.Component {
  static propTypes = {
    /** Open/close dialog */
    open: PropTypes.bool.isRequired,
    /** Set max width for cancel & confirm btns */
    noMaxWidthBtns: PropTypes.bool,
    /** Text for the Dialog title */
    title: PropTypes.string.isRequired,
    /** Text for the cancel button */
    cancelText: PropTypes.string,
    /** Text for the confirm button */
    confirmText: PropTypes.string.isRequired,
    /** Callback fired when cancel button click */
    onCancel: PropTypes.func,
    /** Callback fired when confirm button click */
    onConfirm: PropTypes.func,
    /** Classes injected from MUI Styles */
    classes: PropTypes.object,
    /** Provided children */
    children: PropTypes.node,
  };

  static defaultProps = {
    maxWidth: 'md',
    noMaxWidthBtns: true,
  };

  render() {
    const {
      cancelText,
      maxWidth,
      confirmText,
      onCancel,
      onConfirm,
      title,
      classes,
      children,
      open,
      noCancel,
      noMaxWidthBtns,
      dialogClassName,
      onClose,
      closeIcon,
      disabledbtn
    } = this.props;

    return (
      <Dialog maxWidth={maxWidth} classes={{ root: classes.root, paper: classes.rootPaper }} className={dialogClassName} open={open}>

        <div className={classes.titleContainer}>
        <h2 className={classes.title} id="confirm-title">
          {title}
        </h2>
        {closeIcon &&
         <CloseIcon className={classes.closeIcon} onClick={onClose || null} />}
        </div>       
        <DialogContent classes={{ root: classes.contentRoot }}>
          <DialogContentText classes={{ root: classes.contentText }}>{children}</DialogContentText>
        </DialogContent>
        <div className={classes.divider} />
        <DialogActions classes={{ root: classes.actionsRoot, action: classes.buttonAction }}>
          {!noCancel && (
            <Button onClick={onCancel || null} noMaxWidth={noMaxWidthBtns} styleType={'secondary'}>
              {cancelText}
            </Button>
          )}
          <Button disabled={disabledbtn} onClick={onConfirm || null} noMaxWidth={noMaxWidthBtns}>
            {confirmText}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export { ConfirmDialog };
export default styled(ConfirmDialog)(styles);



// WEBPACK FOOTER //
// ./src/ui/library/Dialog/ConfirmDialogBase.js